// extracted by mini-css-extract-plugin
export default {"editor":"editor___c00df46cdc6a1c9189b9"};